/* unplugin-vue-components disabled */import { render } from "./coveoAiIcon.vue?vue&type=template&id=3325f17a"
import script from "./coveoAiIcon.vue?vue&type=script&lang=js"
export * from "./coveoAiIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__